import React from 'react'
import StaffInvitation from '../components/staffInvitation/StaffInvitation'

const Invite = () => {
    return (
        <div>
            <StaffInvitation />
        </div>
    )
}

export default Invite